// extracted by mini-css-extract-plugin
export default {"container":"new_89P6s","header":"new_hea_2-_Zr","form":"new_for_1aeRB","line":"new_lin_2Vs5W","label":"new_lab_PdfKz","value":"new_val_2roE2","recipient":"new_rec_27RR3"};